import { Container } from "@mui/material";
import LaancStyles from "../styles/LaancStatment.module.css";
import laanc_approved from "../assests/laanc_approved.png";
import flyzone_flightloop from "../assests/flyzone_by_flightloop.png";

function LaancGeneral() {
    return (
        <Container className={LaancStyles.statement_body}>
            <div className={LaancStyles.content_card}>
                <div className={LaancStyles.logo_container}>
                    <div className={LaancStyles.laanc_approved_logo}>
                        <img src={laanc_approved} alt="LAANC Approved" />
                    </div>
                    <div className={LaancStyles.new_logo}>
                        <img src={flyzone_flightloop} alt="Flyzone by Flightloop" />
                    </div>
                </div>
                <p className={LaancStyles.statement_p}>
                    Flyzone is a product offered by{" "}
                    <a
                        href="https://www.flightloop.com.au/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <u>Flightloop</u>
                    </a>
                    , an FAA-approved UAS Service Supplier (USS) of the LAANC (
                    <a
                        href="https://www.faa.gov/uas/getting_started/laanc"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <u>
                            <span>
                                Low Altitude Authorization and Notification
                                Capability
                            </span>
                        </u>
                    </a>
                    ).
                </p>

                <h1 className={LaancStyles.statement_h1}>What is LAANC?</h1>

                <p className={LaancStyles.statement_p}>
                    LAANC is a collaboration between the FAA and private
                    industry, like Flightloop, to safely integrate small drones
                    into the national airspace system. Flightloop provides
                    remote pilots and recreational flyers with airspace
                    awareness and the opportunity to receive authorizations to
                    fly in controlled airspace (under 400 feet) through the
                    Flyzone{" "}
                    <a
                        href="https://laanc.flyzone.io"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <u>
                            <span>web app</span>
                        </u>
                    </a>
                    .
                </p>

                <p className={LaancStyles.statement_p}>
                    Drone pilots planning to fly below 400 feet in controlled
                    airspace must obtain airspace authorization from the FAA
                    before flying. The LAANC system automates this process,
                    providing quick approvals for pilots operating under the{" "}
                    <a
                        href="https://www.faa.gov/uas/commercial_operators"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <u>Small UAS Rule (Part 107) </u>
                    </a>{" "}
                    or the{" "}
                    <a
                        href="https://www.faa.gov/uas/recreational_flyers/knowledge_test_updates"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {" "}
                        <u>Exception for Recreational Flyers </u>
                    </a>
                    . To qualify under Part 107, pilots must register their
                    drone and hold a{" "}
                    <a
                        href="https://www.faa.gov/uas/commercial_operators/become_a_drone_pilot"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {" "}
                        <u>Remote Pilot Certificate </u>
                    </a>
                    , while recreational flyers are required to complete{" "}
                    <a
                        href="https://www.faa.gov/uas/recreational_flyers/knowledge_test_updates"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {" "}
                        <u>The Recreational UAS Safety Test </u>
                    </a>
                    (TRUST) before taking flight. Drone pilots can use LAANC to
                    request airspace authorization up to 90 days in advance of
                    their planned operation.
                </p>

                <p className={LaancStyles.statement_p}>
                    Flyzone provides automatic airspace authorizations to Part
                    107 pilots and Recreational Flyers. Currently, Flyzone does
                    not support further coordination (FC) requests.
                </p>

                <p className={LaancStyles.statement_p}>
                    LAANC services are available only for obtaining airspace
                    authorizations within the United States.
                </p>
            </div>
        </Container>
    );
}

export default LaancGeneral;